import { Record } from "immutable";
import type { RecordOf } from "immutable";
import type { Filters, Sorting } from "@fas/ui-framework";
import {
  SET_PAGES_LIST,
  SET_PAGES_LIST_COUNT,
  ADD_SELECTED_PAGE,
  REMOVE_SELECTED_PAGE,
  CHANGE_DOCUMENT_VERSION_STATUS,
  PAGES_LIST_SET_PAGE,
  PAGES_LIST_SET_SORTING,
  PAGES_LIST_SET_FILTERS,
  PAGES_LIST_SET_PAGE_SIZE,
} from "../../helpers/constants";
import type { Page } from "../../components/PagesList/types/PagesList.types";
import type {
  Actions,
  SetPagesList,
  SetPagesListCount,
  AddSelectedPage,
  RemoveSelectedPage,
  SetPage,
  SetFilters,
  SetSortings,
  ChangeDocumentVersionStatus,
  SetPageSize,
} from "../../actions/pages";


export type DefaultStateType = {
  data: Array<Page>,
  selected: Array<string>,
  count: number,
  page: number,
  pageSize: number,
  filters: Filters,
  sorting: Sorting,
};

export const defaultState: DefaultStateType = {
  data: [],
  selected: [],
  count: 0,
  page: 1,
  pageSize: 10,
  filters: {},
  sorting: {},
};

export const makeState = Record(defaultState);

export type State = RecordOf<DefaultStateType>;

export const initialState: State = makeState({});

export function initPagesState(
  args: {
    page?: number,
    pageSize?: number,
    filters?: Filters,
    sorting?: Sorting,
  } = {}
): State {
  return makeState(args);
}

// eslint-disable-next-line default-param-last
const pagesReducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case SET_PAGES_LIST: {
      const { data } = action as SetPagesList;
      return state.set("data", data);
    }
    case SET_PAGES_LIST_COUNT: {
      const { count } = action as SetPagesListCount;
      return state.set("count", count);
    }
    case ADD_SELECTED_PAGE: {
      const { selectedPage } = action as AddSelectedPage;
      return state.update(
        "selected",
        (selected: Array<string>): Array<string> => [...selected, selectedPage]
      );
    }
    case REMOVE_SELECTED_PAGE: {
      const { removedPage } = action as RemoveSelectedPage;
      return state.update(
        "selected",
        (selected: Array<string>): Array<string> => selected.filter((x: string): boolean => x !== removedPage)
      );
    }
    case CHANGE_DOCUMENT_VERSION_STATUS: {
      const { documentId, status } = action as ChangeDocumentVersionStatus;
      const documentIndex = state
        .get("data")
        .findIndex(({ documentId: docId }) => docId === documentId);
      return state.updateIn(
        ["data", documentIndex, "versionCollection", 0],
        (x: any) => ({ ...x, version: status })
      );
    }
    case PAGES_LIST_SET_PAGE: {
      const { page } = action as SetPage;
      return state.set("page", page);
    }
    case PAGES_LIST_SET_SORTING: {
      const { sorting } = action as SetSortings;
      return state.set("sorting", sorting);
    }
    case PAGES_LIST_SET_FILTERS: {
      const { filters } = action as SetFilters;
      return state.set("filters", filters);
    }
    case PAGES_LIST_SET_PAGE_SIZE: {
      const { pageSize } = action as SetPageSize;
      return state.set("pageSize", pageSize).set("page", 1);
    }
    default:
      return state;
  }
};

export default pagesReducer;
